"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const rateLimiter = require("@tanstack/pacer/rate-limiter");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useRateLimiter(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().rateLimiter,
    ...options
  };
  const [rateLimiter$1] = react.useState(() => new rateLimiter.RateLimiter(fn, mergedOptions));
  rateLimiter$1.fn = fn;
  rateLimiter$1.setOptions(mergedOptions);
  const state = reactStore.useStore(rateLimiter$1.store, selector);
  return react.useMemo(
    () => ({
      ...rateLimiter$1,
      state
    }),
    // omit `store` in favor of `state`
    [rateLimiter$1, state]
  );
}
exports.useRateLimiter = useRateLimiter;
//# sourceMappingURL=useRateLimiter.cjs.map
